<template>
    <div>
      <v-dialog v-model="habilitar" persistent width="1200">
        <v-card color="#3c8dbc" dark>
          <v-card-title>
            <v-row justify="center">
              <v-col class="text-h5 text-bold" cols="auto">
                {{ texto }}
              </v-col>
            </v-row>
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-title>
        </v-card>
      </v-dialog>
    </div>
</template>

<script>
export default {
  props: {
    habilitar: Boolean,
    texto: String
  }
}
</script>